import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MapWallDisplayFacade } from '@app/features/operating-picture/map-wall-display/store';
import { FolderUtils } from '@app/modules/cop/services/map/folder-utils';
import { SectionType } from '@app/modules/cop/store/cop';
import { SwitchComponent } from '@app/modules/core/components/switch/switch.component';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetConfigFormTemplate } from '../widget-config-form-template';

@Component({
  selector: 'topo-alerts-feed-widget-config-form',
  imports: [ReactiveFormsModule, TranslatePipe, SwitchComponent],
  templateUrl: './alerts-feed-widget-config-form.component.html',
  styleUrl: './alerts-feed-widget-config-form.component.scss'
})
export class AlertsFeedWidgetConfigFormComponent extends WidgetConfigFormTemplate implements OnInit {
  protected state = inject(MapWallDisplayFacade);
  protected isReady = signal(false);

  alertLayers = computed(() => {
    const { foldersSet } = this.state.mapState();
    const result = Object.values(foldersSet).reduce(
      (acc, folder) => {
        if (folder.sectionType === SectionType.Alerts) {
          const folderLayers = FolderUtils.getAllLayersInFolder(folder);
          folderLayers.forEach(({ uId, name }) => {
            acc.push({ uId, name });
          });
        }

        return acc;
      },
      [] as Array<{ uId: string; name: string }>
    );

    return result;
  });

  ngOnInit(): void {
    const layers = this.alertLayers();

    const parentGroup = this.form.get('alertsFeedSettings') as FormGroup;

    const existingStateMap = parentGroup.get('includedLayers').value ?? {};

    const groupWithControls = this.fb.group({});

    layers.forEach(({ uId }) => {
      const existingState = existingStateMap[uId];
      groupWithControls.addControl(uId, this.fb.control(typeof existingState === 'boolean' ? existingState : true));
    });

    parentGroup.setControl('includedLayers', groupWithControls);

    this.isReady.set(true);
  }
}
